import {createApp} from 'vue';
import ConfirmModal from '../../components/ConfirmModal.vue';

document.addEventListener('DOMContentLoaded', () => {
    const forms = document.querySelectorAll('form[data-confirm]');
    if (forms.length === 0) {
        return;
    }

    const el = document.createElement('div');
    document.body.appendChild(el);
    createApp(ConfirmModal).mount(el);

    for (const form of forms) {
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            window.openConfirmModal({
                message: form.dataset.confirm,
                submit: form.dataset.confirmSubmit ?? form.querySelector('[type="submit"]')?.textContent.trim() ?? '',
                cancel: form.dataset.confirmCancel ?? '',
                subject: form.dataset.confirmSubject,
                image: form.dataset.confirmImage,
                onConfirm: () => form.submit(),
            });
        });
    }
});
